
import { Search } from 'vant'
import { errorModal } from '../../../assets/js/xjcommon';

export default {
  name: 'home',
  components: {
    [Search.name]: Search
  },
  data () {
    return {
      // 语音拍照/视频
      voice_photo: {},
      voice_video: {},
      // 实时拍照/视频
      realtime_photo: {},
      realtime_video: {},
      // 休眠震动报警照片/视频
      accOff_photo: {},
      accOff_video: {},
      // 行车碰撞照片/视频
      lock_photo: {},
      lock_video: {},
      listPhotoType: [{
        type: [7],
        labelKey:["realtime_photo"],
        name: "实时照片",
        hasData:false,
        label: "realtime_photo",
        thumb:require("../../../assets/images/album/ic_realtime_photo.png")
    },{
        type: [8],
        labelKey:["realtime_video"],
        name: "实时视频",
        hasData:false,
        label: "realtime_video",
        thumb:require("../../../assets/images/album/ic_realtime_video.png")
    }, {
        type: [11, 12],
        name: "停车报警",
        hasData:false,
        labelKey:["accOff_photo","accOff_video"],
        label: "park_photo_video",
        thumb:require("../../../assets/images/album/ic_lock_photo.png")
    },{
        type: [5, 6, 15, 16],
        name: "行车碰撞",
        hasData:false,
        labelKey:["lock_photo","lock_video","lock_video_banma","lock_photo_banma"],
        label: "lock_photo_video_banma",
        thumb:require("../../../assets/images/album/ic_lock_photo.png")
    }, {
        type: [14],
        name: "紧急视频",
        hasData:false,
        labelKey:["sos_video"],
        label: "sos_video",
        thumb:require("../../../assets/images/album/ic_accoff_photo.png")
    },{
        type: [3, 4, 21 ,22],
        name: "设备抓拍",
        hasData:false,
        labelKey:["voice_photo","voice_video","key_press_capture_photo","key_press_capture_video"],
        label: "voice_photo_video",
        thumb:require("../../../assets/images/album/ic_voice_photo.png")
    }],
      pic:require('../../../assets/images/xc_3d_pic.png'),
      sp:require('../../../assets/images/xc_3d_sp.png'),
    }
  },
  methods: {
    initPhotoAlbumFn () {
      let _this = this;
      this.$toast.loading({
        overlay: true,
        duration: 0,
        message: '加载中...'
      });
      this.$axios.post('/v3/u/album/dayCover')
        .then((response)=>{
          // console.log(response);
          if (response.data.ret === 0) {
            const reqData = response.data.data;
            // // 语音拍照/视频
            // _this.voice_photo = { count: reqData.voice_photo.count, thumb: reqData.voice_photo.camera === 4 ? _this.pic : reqData.voice_photo.thumb };
            // _this.voice_video = { count: reqData.voice_video.count, thumb: reqData.voice_video.camera === 4 ? _this.sp :  reqData.voice_video.thumb};
            // // 实时拍照/视频
            // _this.realtime_photo = { count: reqData.realtime_photo.count, thumb: reqData.realtime_photo.camera === 4 ? _this.pic : reqData.realtime_photo.thumb};
            // _this.realtime_video = { count: reqData.realtime_video.count, thumb: reqData.realtime_video.camera === 4 ? _this.sp : reqData.realtime_video.thumb};
            // // 休眠震动报警照片/视频
            // _this.accOff_photo = {
            //   count: reqData.accOff_photo.count + reqData.accOff_photo_banma.count, thumb: (reqData.accOff_photo.camera === 4 || reqData.accOff_photo_banma.camera=== 4) ? _this.pic: (reqData.accOff_photo.thumb ||reqData.accOff_photo_banma.thumb)
            // };
            // _this.accOff_video = { count: reqData.accOff_video.count + reqData.accOff_video_banma.count, thumb: (reqData.accOff_video.camera === 4 || reqData.accOff_video_banma.camera=== 4) ? _this.sp: (reqData.accOff_video.thumb ||reqData.accOff_video_banma.thumb)
            // };
            // // 行车碰撞照片/视频
            // _this.lock_photo = { count: reqData.lock_photo.count + reqData.lock_photo_banma.count, thumb: (reqData.lock_photo.camera === 4 || reqData.lock_photo_banma.camera=== 4) ? _this.pic: (reqData.lock_photo.thumb ||reqData.lock_photo_banma.thumb),
            //   };
            // _this.lock_video = { count: reqData.lock_video.count + reqData.lock_video_banma.count,
            //   thumb: (reqData.lock_video.camera === 4 || reqData.lock_video_banma.camera=== 4) ? _this.sp: (reqData.lock_video.thumb ||reqData.lock_video_banma.thumb),
            // };
            const reDefineListPhotoType  = this.listPhotoType.map(item=>{
              const v = item.labelKey.map(items => reqData[items]);
              const first  = v.find(fItem=>fItem.thumb)||{thumb:null}
              const reqDataCon = {
                  count: v.reduce((t,itm)=>t+(itm.count||0),0),
                  hasData:first.thumb,
                  thumb:first.thumb || item.thumb
              }
              return {
                  ...item,
                  ...reqDataCon,
              }
          })
          this.listPhotoType = reDefineListPhotoType;


            // 关闭加载状态
            this.$toast.clear();
          } else {
            this.$toast.clear();
            this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取相册信息失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 141);
        })
    },
    toPhotoListPageFn (type) {
      this.$router.push('/photoList?type=' + type.join(","));
    }
  },
  created () {
    this.initPhotoAlbumFn();
  }
}
